import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
import { PhoneIcon, CheckIcon } from 'lucide-react';
import { useApp } from '../context/AppContext';
export const Login: React.FC = () => {
  const navigate = useNavigate();
  const {
    setUser
  } = useApp();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [showOtp, setShowOtp] = useState(false);
  const handleContinue = () => {
    if (!showOtp) {
      // In a real app, this would send the OTP
      setShowOtp(true);
    } else {
      // In a real app, this would verify the OTP
      setUser({
        id: '1',
        name: 'Jared',
        phone: phoneNumber,
        isLoggedIn: true
      });
      navigate('/');
    }
  };
  return <div className="min-h-screen bg-background flex flex-col p-6" data-id="element-430">
      <div className="flex-1 flex flex-col justify-center items-center" data-id="element-431">
        <div className="w-full max-w-md" data-id="element-432">
          <div className="mb-12 text-center" data-id="element-433">
            <h1 className="text-4xl font-bold text-primary mb-2" data-id="element-434">JomGo</h1>
            <p className="text-white text-opacity-80" data-id="element-435">
              Fast, reliable cross-border transport
            </p>
          </div>
          <div className="mb-8" data-id="element-436">
            <h2 className="text-2xl font-semibold mb-6" data-id="element-437">
              {showOtp ? 'Verify your phone' : 'Enter your phone number'}
            </h2>
            {!showOtp ? <div className="relative mb-6" data-id="element-438">
                <div className="absolute left-4 top-1/2 transform -translate-y-1/2" data-id="element-439">
                  <PhoneIcon size={20} className="text-primary" data-id="element-440" />
                </div>
                <input type="tel" className="input-field pl-12" placeholder="+60 or +65 phone number" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} data-id="element-441" />
              </div> : <div className="mb-6" data-id="element-442">
                <div className="grid grid-cols-4 gap-3" data-id="element-443">
                  {[...Array(4)].map((_, i) => <input key={i} type="text" maxLength={1} className="input-field text-center text-xl py-4" value={otp[i] || ''} onChange={e => {
                const newOtp = otp.split('');
                newOtp[i] = e.target.value;
                setOtp(newOtp.join(''));
              }} data-id="element-444" />)}
                </div>
                <p className="text-white text-opacity-60 text-sm mt-3 text-center" data-id="element-445">
                  We sent a code to {phoneNumber}
                </p>
              </div>}
            <Button onClick={handleContinue} data-id="element-446">
              {showOtp ? 'Verify' : 'Continue'}
            </Button>
            {showOtp && <button className="w-full text-center text-primary mt-4" onClick={() => setShowOtp(false)} data-id="element-447">
                Change phone number
              </button>}
          </div>
        </div>
      </div>
      <div className="w-full text-center text-white text-opacity-60 text-sm" data-id="element-448">
        By continuing, you agree to our Terms of Service and Privacy Policy
      </div>
    </div>;
};